// Icon sizes
export const ICON_SIZES = {
  ERROR_ICON: 16, // px
  PASSWORD_ICON_BUTTON: 40, // px (icon + padding + margin)
} as const

// Tooltip dimensions
export const TOOLTIP_CONFIG = {
  ARROW_WIDTH: 12, // px (6px left + 6px right border)
  ARROW_HEIGHT: 6, // px
  BACKGROUND_COLOR: '#252422',
  MAX_WIDTH: 300, // px
  PADDING: '8px 12px',
  BORDER_RADIUS: '8px',
  FONT_SIZE: '14px',
  FONT_WEIGHT: 300,
  LINE_HEIGHT: 1.5,
} as const

// Input configuration
export const INPUT_CONFIG = {
  PADDING_RIGHT: 12, // px - MUI default input padding
} as const
const PADDING_BUTTON_DEFAULT = 8
const STACK_SPACING = 4 // px - spacing={0.5} in MUI = 4px (theme.spacing(0.5))

// Calculate arrow position based on icons present
export const calculateArrowPosition = (hasPasswordIcon: boolean, hasOtherIcon?: boolean): number => {
  const { PADDING_RIGHT } = INPUT_CONFIG
  const { ERROR_ICON, PASSWORD_ICON_BUTTON } = ICON_SIZES
  const { ARROW_WIDTH } = TOOLTIP_CONFIG
  // Arrow should point to center of error icon
  const errorIconCenter = ERROR_ICON / 2 // 8px
  const arrowCenter = ARROW_WIDTH / 2 // 6px
  const basedSpacing = STACK_SPACING * ((hasPasswordIcon ? 1 : 0) + (hasOtherIcon ? 1 : 0)) // spacing between icons
  if (hasPasswordIcon) {
    // padding + password icon + stack spacing + error icon center - arrow center
    return PADDING_RIGHT + PASSWORD_ICON_BUTTON + basedSpacing + errorIconCenter - arrowCenter - PADDING_BUTTON_DEFAULT
  }

  // padding + error icon center - arrow center (no spacing needed when no password icon)
  return PADDING_RIGHT + errorIconCenter - arrowCenter + basedSpacing
}
